module.exports = __webpack_public_path__ + "img/logo-icon.58f8a761.png";